<template>
	<div>
		<h2 class="heading-5">{{ $t('simulationType') }}</h2>
		<div class="container-input-checkbox">
			<div
				v-for="(option, index) in simulationTypeOptions"
				:key="index"
				class="option"
			>
				<input
					ref="checkbox"
					v-model="option.isActive"
					:name="option.name"
					type="checkbox"
					class="checkbox"
					@change="simulationTypeCheck(index)"
				/>
				<label :for="option.name" class="body-text-2 input-label">
					{{ option.name }}
				</label>
			</div>
		</div>
		<h2 class="heading-5">{{ $t('image') }}</h2>
		<div class="select-file">
			<img
				:src="sponsorLogoData.logoBase64"
				:alt="sponsorLogoData.name"
				class="thumbnail"
			/>
			<ja-button
				name="selectFile"
				class="small outlined"
				@click.native="openFileSelector"
				>{{ $t('selectFile') }}</ja-button
			>
			<span>{{
				sponsorLogoData.name ? sponsorLogoData.name : $t('chooseAnImage')
			}}</span>
			<input
				ref="fileInput"
				type="file"
				style="display: none;"
				accept=".png, .jpg, .jpeg"
				@change="validateFile"
			/>
		</div>
		<div v-if="fileInfo" class="select-file  selection">
			<ja-button
				name="delete"
				class="outlined button-delete"
				@click.native="removeFile"
				>{{ 'X' }}</ja-button
			>
			<div class="file-info">
				<span>{{ fileInfo + ' ' + imageSize }}</span>
				<span v-if="fileValid" class="text--success">{{
					$t('fileIsUploaded')
				}}</span>
				<span v-if="!fileValid" class="text--warning">{{
					$t('formatPNG')
				}}</span>
			</div>
		</div>
		<h2 class="heading-5">{{ $t('sponsorLogoType') }}</h2>
		<div class="container-input-checkbox">
			<div v-if="selectedFacilityId == 0" class="option">
				<input
					type="checkbox"
					class="checkbox"
					name="option_national"
					disabled
					checked
				/>
				<label for="option_national" class="body-text-2 input-label">{{
					$t('national')
				}}</label>
			</div>
			<div v-else class="option">
				<input
					type="checkbox"
					class="checkbox"
					name="option_national"
					disabled
					checked
				/>
				<label for="option_national" class="body-text-2 input-label">{{
					$t('local')
				}}</label>
			</div>
		</div>
		<div v-if="!sponsorLogoData.isNationalSponsor">
			<label for="option_national" class="heading-5">{{ $t('modules') }}</label>
			<div class="box-businesses">
				<div class="option-businesses" :style="{ 'margin-bottom': '15px' }">
					<input
						v-model="selectedAll"
						type="checkbox"
						class="checkbox"
						name="selectedAll"
					/>
					<label class="heading-5" for="selectedAll">{{
						$t('selectedAll')
					}}</label>
				</div>
				<div v-for="(option, index) in modulesData" :key="index">
					<div class="option-businesses">
						<input
							type="checkbox"
							class="checkbox"
							:name="option.name"
							:checked="isModulesSelected(option.localLogoModule_ID)"
							@change="handleModulesSelection(option, $event.target.checked)"
						/>
						<label class="heading-5" :for="option.name">
							{{ option.name }}
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="!isValid"
				@click.native="saveSponsorLogo"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
			<ja-button name="activated" class="small" @click.native="openModal()">{{
				sponsorLogoData.isActive ? $t('deactivated') : $t('activated')
			}}</ja-button>
		</div>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="isActivated()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					sponsorLogoData.isActive
						? $t('deactivatedMessage')
						: $t('activatedMessageLogo')
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import { simulationTypeArray, ID_NEW_CMS } from '@/helpers/constants';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import { AdminFacility, ResizeImage } from '@/mixins';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaButton: Button
	},
	mixins: [AdminFacility, ResizeImage],
	props: {
		dataEdit: {
			type: Object,
			default: () => {},
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sponsorLogoData: null,
			fileInfo: null,
			fileValid: null,
			simulationTypeOptions: simulationTypeArray,
			modulesData: null,
			imageSize: null,
			selectedAll: false
		};
	},
	computed: {
		isValid() {
			return (
				this.sponsorLogoData.name !== null &&
				(this.sponsorLogoData.logoBase64 !== null || this.fileValid) &&
				(this.sponsorLogoData.isNationalSponsor ||
					(this.sponsorLogoData.isLocalSponsor &&
						this.sponsorLogoData.selectedModules.length > 0))
			);
		}
	},
	watch: {
		selectedAll(newValue) {
			if (newValue) {
				const allsID = this.sponsorLogoData.modules.map(
					b => b.localLogoModule_ID
				);
				this.sponsorLogoData.selectedModules = allsID;
			} else {
				this.sponsorLogoData.selectedModules = [];
			}
		}
	},
	created() {
		this.sponsorLogoData = this.dataEdit;
		this.setInitialIndexes();
	},
	methods: {
		setInitialIndexes() {
			if (this.sponsorLogoData.sponsorLogo_ID === ID_NEW_CMS) {
				this.sponsorLogoData.simulationType_ID = 0;
				this.sponsorLogoData.facility_ID = this.selectedFacilityId;
			}
			if (this.selectedFacilityId > 0) {
				this.sponsorLogoData.isNationalSponsor = false;
				this.sponsorLogoData.isLocalSponsor = true;
			} else {
				this.sponsorLogoData.isNationalSponsor = true;
				this.sponsorLogoData.isLocalSponsor = false;
			}
			this.simulationTypeOptions = simulationTypeArray.map(sim => ({
				...sim,
				isActive: false
			}));
			this.simulationTypeOptions.forEach(sim => {
				if (this.sponsorLogoData.simulationType_ID === sim.id) {
					sim.isActive = true;
				}
			});

			this.modulesData = this.sponsorLogoData.modules.filter(
				item => item.name !== 'PrimaryBillboard'
			);
		},
		simulationTypeCheck(index) {
			const checkbox = this.$refs.checkbox[index];

			this.simulationTypeOptions.forEach((sim, i) => {
				sim.isActive = i === index;
			});
			const selectedTypeID = this.simulationTypeOptions[index].id;
			this.sponsorLogoData.simulationType_ID = selectedTypeID;
			if (
				checkbox.checked === false &&
				this.simulationTypeOptions[index].isActive == true
			) {
				this.$nextTick(() => {
					if (checkbox) {
						checkbox.checked = true;
					}
				});
				return;
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		openFileSelector() {
			this.$refs.fileInput.click();
		},
		async formatFileSize(image, bytes) {
			const maxSizeKB = 300;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			let formattedSize;
			let imageSize;

			if (bytes > maxSizeKB * 1024) {
				const resizedFile = await this.resizeImage(image, maxSizeKB, maxSizeKB);
				const resizedBytes = resizedFile.size;
				const resizedI = parseInt(
					Math.floor(Math.log(resizedBytes) / Math.log(1024))
				);
				formattedSize =
					Math.round(resizedBytes / Math.pow(1024, resizedI), 2) +
					' ' +
					sizes[resizedI];
				imageSize = formattedSize;
				await this.saveFile(resizedFile);
			} else {
				const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
				formattedSize =
					Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
				imageSize = formattedSize;
			}

			this.imageSize = imageSize;
			return formattedSize;
		},
		async validateFile(event) {
			const input = event.target;
			const file = input.files[0];
			this.formatFileSize(file, file.size);
			const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
			this.fileInfo = file.name;
			if (!allowedTypes.includes(file.type)) {
				this.fileValid = false;
				return;
			} else {
				await this.saveFile(file);
			}
		},
		async saveFile(file) {
			const fileDataURL = await this.readFileAsync(file);
			this.sponsorLogoData.logoBase64 = fileDataURL;
			this.sponsorLogoData.name = file.name;
			this.fileValid = true;
		},
		removeFile() {
			this.$refs.fileInput.value = '';
			this.fileInfo = null;
			this.sponsorLogoData.logoBase64 = null;
			this.sponsorLogoData.name = null;
		},
		isModulesSelected(localLogoModule_ID) {
			return this.sponsorLogoData.selectedModules.includes(localLogoModule_ID);
		},
		handleModulesSelection(option, checked) {
			if (checked) {
				this.sponsorLogoData.selectedModules.push(option.localLogoModule_ID);
			} else {
				const index = this.sponsorLogoData.selectedModules.indexOf(
					option.localLogoModule_ID
				);
				if (index !== -1) {
					this.sponsorLogoData.selectedModules.splice(index, 1);
				}
			}
		},
		openModal() {
			this.showMessageDeletionModal = true;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		},
		isActivated() {
			this.sponsorLogoData.isActive = !this.sponsorLogoData.isActive;
			this.saveSponsorLogo();
			this.showMessageDeletionModal = false;
		},
		saveSponsorLogo() {
			this.$emit('saveSponsorLogo', this.sponsorLogoData);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
::v-deep .modal {
	padding: 50px;
}
.save {
	justify-content: flex-end;
}
.container-input-checkbox {
	border: 1px solid $button-border;
	display: flex;
	justify-content: space-between;
	padding: 12px;
	margin-bottom: 25px;
}
.option {
	display: flex;
	align-items: center;
	gap: 10px;
}

.input-label {
	cursor: pointer;
}
.select-file {
	display: flex;
	align-items: center;
	gap: 20px;
	margin: 10px 0 25px;
}
.selection {
	align-items: center;
}
.heading-5 {
	color: $font-dark;
	margin: 10px 0;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
.file-info {
	display: flex;
	flex-direction: column;
	gap: 5px;
}
.button-delete {
	border-radius: 5px;
	width: 30px;
	height: 30px;
}
.thumbnail {
	width: 100px;
	height: auto;
	margin: 5px;
}
.box-businesses {
	border: 1px solid $button-border;
	width: 50%;
	height: 250px;
	padding: 15px;
	overflow: auto;
}
.option-businesses {
	display: flex;
	align-items: center;
	gap: 10px;
}
</style>
